// Copié depuis posrenewed (2026-09-08).
//
// Rendu propre des noms de caissiers, indépendamment de la propreté de la DB :
// ~90% des caissiers ont été créés par un script bulk avec
//   firstname = 'Caissier{N}'
//   lastname  = '{businessNameSlug}'  (ex. 'STEMAINASARL')
// Afficher "Caissier1 STEMAINASARL" à STE MAINA SARL est laid + redondant.

export interface CashierLike {
  cashier_id?: number;
  id?: number;
  firstname?: string | null;
  lastname?: string | null;
  username?: string | null;
}

const AUTO_FIRSTNAME = /^[Cc]aissier\s*(\d+)$/;
const AUTO_USERNAME_DOTTED = /^caissier\s*(\d+)\./i;
const AUTO_USERNAME_TRUNC = /^caissi[a-z](\d+)$/i;

function cleanWord(s: string | null | undefined): string {
  if (!s) return "";
  return s.trim().replace(/\s+/g, " ");
}

function looksLikeBusinessNameSlug(s: string): boolean {
  if (s.length < 5) return false;
  if (/\s/.test(s)) return false;
  if (s !== s.toUpperCase()) return false;
  return true;
}

function titleCase(s: string): string {
  return s
    .toLowerCase()
    .split(/(\s+|-)/)
    .map((part) =>
      /\s+|-/.test(part) ? part : part.charAt(0).toUpperCase() + part.slice(1),
    )
    .join("");
}

export function formatCashierName(c: CashierLike): string {
  const fn = cleanWord(c.firstname);
  const ln = cleanWord(c.lastname);
  const un = cleanWord(c.username);
  const id = c.cashier_id ?? c.id;

  const m1 = fn.match(AUTO_FIRSTNAME);
  if (m1) return `Caissier ${m1[1]}`;

  const m2 = un.match(AUTO_USERNAME_DOTTED);
  if (m2) return `Caissier ${m2[1]}`;

  if (AUTO_USERNAME_TRUNC.test(un)) {
    return id ? `Caissier #${id}` : "Caissier";
  }

  if (ln && looksLikeBusinessNameSlug(ln)) {
    return id ? `Caissier #${id}` : "Caissier";
  }

  const parts = [fn, ln].filter(Boolean).map(titleCase);
  if (parts.length > 0) return parts.join(" ");

  return id ? `Caissier #${id}` : "Caissier";
}

export function cashierInitials(c: CashierLike): string {
  const display = formatCashierName(c);
  const numMatch = display.match(/(?:Caissier\s*#?)\s*(\d+)/i);
  if (numMatch) {
    const n = numMatch[1];
    return `C${n.length > 1 ? n.slice(-2) : n}`;
  }
  const parts = display.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "??";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function cashierSubtitle(c: CashierLike & {
  store_name?: string | null;
  phone_number?: string | null;
}): string {
  const bits: string[] = [];
  if (c.store_name) bits.push(c.store_name);
  else bits.push("Sans magasin");
  if (c.phone_number && c.phone_number !== "00000000000000") {
    bits.push(c.phone_number);
  }
  return bits.join(" · ");
}
